//fetch billing information
import { fetchPayrollById, fetchBillingDetailsByPayrollId } from "pages/payroll/PayrollService"

function normalizeBillingResponse(billingResponse) {
    if (!billingResponse) return null

    if (Array.isArray(billingResponse)) {
        return billingResponse[0] || null
    }

    if (Array.isArray(billingResponse?.data)) {
        return billingResponse.data[0] || null
    }

    return billingResponse
}

export async function getById(billingId) {
    if (!billingId) return null

    try {
        let result = await Promise.all([fetchBillingDetailsByPayrollId(billingId), fetchPayrollById(billingId)])
        let billing = normalizeBillingResponse(result[0])
        let payroll = result[1]

        return { billing, payroll }
    } catch (err) {
        throw err
    }

}

export default {
    getById
}
